module.exports = __webpack_public_path__ + "static/media/ribbons.038af5c4.svg";